module.exports = __webpack_public_path__ + "img/logo.a187a76b.png";